module.exports = __webpack_public_path__ + "fonts/iconfont.03192111.ttf";